/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
/* eslint-disable */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { CommonDropdown, RegularButton, CommonInput, ICommonDropdownOption, AlertAdapter } from 'pg-ui-library';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { Chip } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { DateTime } from 'luxon';
import SupportDeskService from 'src/services/support-desk.service';
import { useAssignUser } from './mutations/add-update-reply-support-ticket';
import { useTranslation } from 'react-i18next';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import { CellSpan, Container, ScreenHeader, RightHeader, PageTitle } from './styles';

export enum Ticket {
  OPEN = 'Open',
  OPEN_value = 'Open',
  IN_PROGRESS = 'In Progress',
  IN_PROGRESS_value = 'In Progress',
  ON_HOLD = 'On Hold',
  ON_HOLD_value = 'On Hold',
  RESOLVED = 'Resolved',
  RESOLVED_value = 'Resolved',
  CANCELLED = 'Cancelled',
  CANCELLED_value = 'Cancelled',
}

const myticketOptions: ICommonDropdownOption[] = [
  {
    key: '0',
    label: 'All',
    value: '',
  },
  {
    key: '1',
    label: Ticket.OPEN,
    value: Ticket.OPEN_value,
  },
  {
    key: '2',
    label: Ticket.ON_HOLD,
    value: Ticket.ON_HOLD_value,
  },
  {
    key: '3',
    label: Ticket.IN_PROGRESS,
    value: Ticket.IN_PROGRESS_value,
  },
  {
    key: '4',
    label: Ticket.RESOLVED,
    value: Ticket.RESOLVED_value,
  },
  {
    key: '5',
    label: Ticket.CANCELLED,
    value: Ticket.CANCELLED_value,
  },
];

interface AllUsers {
  key: string;
  id: string;
  email: string;
}

const SupportDesk: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    cancelled: { color: 'default', label: 'Cancelled', bgColor: '#d32f2f' },
    Cancelled: { color: 'default', label: 'Cancelled', bgColor: '#d32f2f' },

    open: { color: 'default', label: 'Open', bgColor: '#1976d2' },
    Open: { color: 'default', label: 'Open', bgColor: '#1976d2' },

    inProgress: { color: 'default', label: 'In Progress', bgColor: '#0288d1' },
    InProgress: { color: 'default', label: 'In Progress', bgColor: '#0288d1' },
    'In Progress': { color: 'default', label: 'In Progress', bgColor: '#0288d1' },

    onHold: { color: 'default', label: 'On Hold', bgColor: '#ffa000' },
    OnHold: { color: 'default', label: 'On Hold', bgColor: '#ffa000' },
    'On Hold': { color: 'default', label: 'On Hold', bgColor: '#ffa000' },

    solved: { color: 'default', label: 'Solved', bgColor: '#388e3c' },
    resolved: { color: 'default', label: 'Solved', bgColor: '#388e3c' },
    Resolved: { color: 'default', label: 'Solved', bgColor: '#388e3c' },
  };

  const assignUser = useAssignUser();
  const ticketDetail = (ticket: any) => {
    navigate(`/ticket-detail/${ticket.id}`);
  };

  const supportTicketTableColumns: GridColDef[] = [
    {
      headerName: 'ID',
      headerClassName: 'CommonHeaderClass',
      field: 'supportNumber',
      minWidth: 90,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => ticketDetail(params.row)}>
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Full Name',
      headerClassName: 'CommonHeaderClass',
      field: 'userFirstName',
      minWidth: 150,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const { userFirsName, userMiddleName, userLastName } = params.row;

        let fullName = '';
        if (userFirsName) fullName += userFirsName;
        if (userMiddleName) fullName += ` ${userMiddleName}`;
        if (userLastName) fullName += ` ${userLastName}`;

        fullName = fullName.trim();

        return (
          <CellSpan title={fullName} data-tag="allowRowEvents">
            {fullName || 'No Name Available'}
          </CellSpan>
        );
      },
    },
    {
      headerName: 'Company',
      headerClassName: 'CommonHeaderClass',
      field: 'companyName',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Module',
      headerClassName: 'CommonHeaderClass',
      field: 'module',
      minWidth: 90,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const module = (params.value as string).toLowerCase();
        let label = '';
        if (module === 'hrprofile' || module === 'hr_profile') {
          label = 'Profile';
        } else if (module === 'benefit' || module === 'benefits') {
          label = 'Benefits';
        } else if (module === 'pay_history' || module === 'payroll') {
          label = 'Payroll';
        } else if (module === 'tax' || module === 'tax_forms') {
          label = 'Tax';
        } else {
          label = params.value as string;
        }

        return (
          <CellSpan title={label} data-tag="allowRowEvents">
            {label}
          </CellSpan>
        );
      },
    },
    {
      headerName: 'Subject',
      headerClassName: 'CommonHeaderClass',
      field: 'subject',
      minWidth: 120,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents">
          {params.value}
        </CellSpan>
      ),
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Sub Category',
      headerClassName: 'CommonHeaderClass',
      field: 'subCategory',
      minWidth: 100,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Description',
      headerClassName: 'CommonHeaderClass',
      field: 'description',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Priority',
      headerClassName: 'CommonHeaderClass',
      field: 'priority',
      minWidth: 75,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Created At',
      headerClassName: 'CommonHeaderClass',
      field: 'CreatedTo',
      minWidth: 120,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const formattedDate = DateTime.fromISO(params.value).toFormat('yyyy-MM-dd');
        return <CellSpan title={params.value}>{formattedDate}</CellSpan>;
      },
    },
    {
      headerName: 'Attachments',
      headerClassName: 'CommonHeaderClass',
      field: 'attachments',
      minWidth: 180,
      renderCell: params => {
        const attachments = params.value as { attachmentName?: string }[];
        if (attachments && attachments.length > 0) {
          return (
            <CellSpan title={attachments[0].attachmentName} data-tag="allowRowEvents">
              {attachments[0].attachmentName}
            </CellSpan>
          );
        }
        return <CellSpan>No Attachments</CellSpan>;
      },
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 150,
      renderCell: params => {
        const status = params.value as string;
        const { color, label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              fontSize: '12px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              borderRadius: '6px',
            }}
          />
        );
      },
    },
  ];

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [statusTicket, setStatusTicket] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedUser, setSelectedUser] = useState<string>('');
  const [selectedUserId, setSelectedUserId] = useState<string>('');
  const isButtonEnabled = selectedRows.length > 0 && selectedUser !== '';
  const companyId = '';
  const [searchUsers, setSearchUsers] = useState('');

  const { isFetching, data } = useQuery(
    ['support-desk', page, limit, searchTerm, status, sortBy, sortDirection],
    async () => {
      return await SupportDeskService.getSupportTickets({
        companyId,
        page,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        status,
      });
    }
  );

  const usersSearch = useQuery<AxiosResponse<{ items: AllUsers[] }>>(['/admin/users/search'], async () => {
    try {
      const result = await SupportDeskService.getUsersSearchNewSupport(searchUsers);
      return result;
    } catch (e) {
      const errorMessage = 'Error While Fetching the users';
      AlertAdapter(errorMessage, 'error');
      throw new Error(errorMessage);
    }
  });
  const options =
    usersSearch.data?.data.items.map((user: any) => ({
      key: user.id,
      label: user.name,
      value: user.email,
    })) || [];

  // useEffect(() => {
  //   refetch();
  // }, [page, limit, status, searchTerm, refetch]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  const onPageMetaChange = (model: any) => {
    setPage(model.page + 1);
    setLimit(model.pageSize);
  };

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const formattedData = data?.items?.map((row: any, index: number) => ({
    ...row,
    id: row.id || index + 1,
  }));

  const exportToExcel = (): void => {
    if (!formattedData || formattedData.length === 0) {
      AlertAdapter('No data available to export', 'error');
      return;
    }

    const selectedTicketsForExport = formattedData.filter(ticket => selectedRows.includes(ticket.id));

    const ticketsForExport = selectedTicketsForExport.map(ticket => ({
      'Ticket Id': ticket.supportNumber,
      'Full Name': `${ticket.userFirstName || ''} ${ticket.userMiddleName || ''} ${ticket.userLastName || ''}`.trim(),
      Company: ticket.companyName,
      Module: ticket.module,
      Subject: ticket.subject,
      'Sub Category': ticket.subCategory,
      Description: ticket.description,
      Priority: ticket.priority,
      Created: DateTime.fromISO(ticket.CreatedTo).toFormat('yyyy-MM-dd'),
      Attachments:
        ticket.attachments && ticket.attachments.length > 0 ? ticket.attachments[0].attachmentName : 'No Attachments',
      status: ticket.status,
    }));

    exportToXLSX(ticketsForExport, 'selected-tickets', 'selected-tickets');
  };

  const assignTickets = async () => {
    const assignUserSet = {
      supportTicketId: selectedRows,
      userId: selectedUserId,
    };
    await assignUser.mutateAsync({ assignUser: assignUserSet });
    AlertAdapter('User has been assigned to the ticket', 'success');
  };

  return (
    <Container>
      <ScreenHeader>
        <PageTitle>Support desk</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <CommonInput
            id="searchQuery"
            name="searchQuery"
            placeholder="Search..."
            value={searchTerm}
            onChange={event => {
              let newValue = event.target.value;
              newValue = newValue.replace(/[',.]/g, '');
              setsearchTerm(newValue);
            }}
            style={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '5px',
            }}
            label=""
          />

          <CommonDropdown
            label=""
            id="statusTicket"
            name="statusTicket"
            options={myticketOptions}
            value={statusTicket}
            setValue={(value: string) => {
              setStatusTicket(value);
              setStatus(value);
            }}
            selectStyle={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />

          <CommonDropdown
            label=""
            id="assigneee"
            name="assigneee"
            options={[{ key: '', label: 'Select Assignee', value: '' }, ...options]}
            value={selectedUser}
            setValue={(value: string) => {
              const selectedUsers = usersSearch.data?.data.items.find(user => user.email === value);
              if (selectedUsers) {
                setSelectedUser(value);
                setSelectedUserId(selectedUsers.id);
              }
            }}
            selectStyle={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
            }}
          />

          <RegularButton onClick={assignTickets} disabled={!isButtonEnabled}>
            Assign
          </RegularButton>

          <RegularButton onClick={exportToExcel}>{t('global.form.export')}</RegularButton>
        </RightHeader>
      </ScreenHeader>

      <div>
        {isFetching || !formattedData ? (
          <div style={{ minHeight: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <span>Loading...</span>
          </div>
        ) : formattedData.length > 0 ? (
          <DataGrid
            rows={formattedData}
            columns={supportTicketTableColumns}
            pagination
            paginationMode="server"
            onPaginationModelChange={state => onPageMetaChange(state)}
            onSortModelChange={state => onSortMetaChange(state)}
            onRowSelectionModelChange={newSelectionModel => setSelectedRows(newSelectionModel)}
            // initialState={{
            //   pagination: {
            //     paginationModel: { page: 0, pageSize: 10 },
            //   },
            // }}
            paginationModel={{
              page: page - 1,
              pageSize: limit,
            }}
            pageSizeOptions={[10, 20, 50]}
            rowCount={data?.meta.totalItems}
            loading={isFetching}
            disableColumnFilter
            checkboxSelection
            sx={{
              font: '14px Biotif',
              fontWeight: 'bold',
              '& .CommonHeaderClass': {
                color: '#9399B2',
                font: '16px Biotif',
                fontWeight: 'bold',
              },
              minHeight: '150px',
              background: '#fff',
            }}
          />
        ) : (
          <div style={{ minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            No Support ticket to display.
          </div>
        )}
      </div>
    </Container>
  );
};

export default SupportDesk;
